/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
//import iconChart from '../../../img/icon-chart.svg';
//import iconWarning from '../../../img/icon-warning.svg';
//import iconCalendar from '../../../img/icon-calendar.svg';
import calendarIcon from '../../../img/calendar-icon.svg';
import creditCard from '../../../img/credit-card.svg';
import srMarker from '../../../img/sr-marker.svg';
//import searchIcon from '../../../img/search-icon.svg';
import TrophyIcon from '../../../img/trophy-icon.svg';
//import $ from 'jquery';
import moment from 'moment';
import api from '../../../services/api';
import { Dropdown } from 'react-bootstrap';
//import { formatDurationWithOptions } from 'date-fns/fp';
//import DonutChart from 'react-donut-chart';
import { ChartDonut } from '@patternfly/react-charts';
import { ChartThemeColor } from '@patternfly/react-charts';
//import DatePicker from 'react-datepicker';
//import ReactInputMask from 'react-input-mask';
//import Calendar from 'react-calendar';

//import 'react-date-range/dist/styles.css'; // main css file
//import 'react-date-range/dist/theme/default.css'; // theme css file
//import { pt } from 'date-fns/locale';

//import { DateRangePicker, DateRange } from 'react-date-range';

//import 'react-calendar/dist/Calendar.css';
import '../calendar.css';
import CalendarDropDown from './calendar/Calendar';
import NumberFormat from 'react-number-format';
import replaceSpecialChars from '../../../utils/replaceSpecialChars';
import { X_FOWARD_HOST } from '../../../utils/env';

// olhar esse site https://www.patternfly.org/v4/charts/donut-chart/
//olhar esses sites https://medium.com/swlh/how-to-build-a-simple-and-interactive-bar-chart-with-react-js-and-css-in-js-6d48f0924d25
//https://apexcharts.com/react-chart-demos/bar-charts/

/**
 *
 * para personalizado checar
 * react-calendar
 * react-date-picker
 * react-daterange-picker
 *
 *
 *
 *
 */

function Dash() {
	const diaDaSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];

	function stringToDate(str) {
		////console.log(str);
		//const parts = str.split('/');
		return moment(str, 'DD/MM/YYYY').toDate();
		//return new Date(parts[2], parts[1] - 1, parts[0]);
	}

	/*const data = [
		{ valor: 1500, nome: 'Débito', color: '#7D9828' },
		{ valor: 900, nome: 'Credito a Vista', color: '#D3DCB7' },
		{ valor: 2000, nome: 'Credito Parcelado', color: '#F0F3E7' },
	];*/

	const secondChart = React.useRef(null);

	//const [chartWidth, setChartWidth] = useState(0);

	function renderMoney(value) {
		value = parseFloat(value);
		return value.toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
		});
	}

	function renderMoneyWithCedule(value) {
		value = parseFloat(value);
		return value.toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}

	const [dataCartao, setDataCartao] = useState(moment().format('DD/MM/YYYY'));
	const [dataCartaoPre, setDataCartaoPre] = useState(
		moment().format('DD/MM/YYYY')
	);
	const [dataCartaoDiaSemana, setDataCartaoDiaSemana] = useState('');
	const [calendarCartaoDropDown, setCalendarCartaoDropdown] = useState(false);
	const [filtroDiaCartao, setFiltroDiaCartao] = useState('Hoje');
	const [loadingDataCartao, setLoadingDataCartao] = useState(true);
	const [cartaoInfo, setCartaoInfo] = useState({
		amount: { total: 0, percent: 0 },
		currency: { total: 0, percent: 0 },
		online: { total: 0, percent: 0 },
		terminal: { total: 0, percent: 0 },
	});

	const [dataOp, setDataOp] = useState(moment().format('DD/MM/YYYY'));
	const [dataOpPre, setDataOpPre] = useState(moment().format('DD/MM/YYYY'));
	const [dataOpDiaSemana, setDataOpDiaSemana] = useState('');
	const [calendarOpDropDown, setCalendarOpDropdown] = useState(false);
	const [filtroDiaOp, setFiltroDiaOp] = useState('Hoje');
	const [loadingDataOp, setLoadingDataOp] = useState(true);
	const [operacaoInfo, setOperacaoInfo] = useState({
		credit: { total: 0, percent: 0 },
		credit_parceled: { total: 0, percent: 0 },
		debit: { total: 0, percent: 0 },
		total: 0,
	});
	//const [porcentagemdebit, setPorcentagemDebit] = useState(0);
	//const [porcentagemcredit, setPorcentagemcredit] = useState(0);
	//const [porcentagemcredit_parceled, setPorcentagemcredit_parceled] = useState(
	//		0
	//	);

	const [dataUni, setDataUni] = useState(moment().format('DD/MM/YYYY'));
	const [dataUniPre, setDataUniPre] = useState(moment().format('DD/MM/YYYY'));
	const [dataUniDiaSemana, setDataUniDiaSemana] = useState('');
	const [calendarUniDropDown, setCalendarUniDropdown] = useState(false);
	const [filtroDiaUni, setFiltroDiaUni] = useState('Hoje');
	const [loadingDataUni, setLoadingDataUni] = useState(true);
	//const [unidadeNomeSearch, setUnidadeNomeSearch] = useState('');
	const [unidadeInfo, setUnidadeInfo] = useState({
		nome: 'Manaus',
		data: [
			{ valor: 0, nome: 'Débito', color: '#7D9828', percent: 0 },
			{ valor: 0, nome: 'Credito a Vista', color: '#D3DCB7', percent: 0 },
			{ valor: 0, nome: 'Credito Parcelado', color: '#F0F3E7', percent: 0 },
		],
		total: 0,
	});
	const [unidade, setUnidade] = useState('');
	const [unidadeSearch, setUnidadeSearch] = useState('');
	const [unidades, setUnidades] = useState([]);
	const [loadUnidades, setLoadUnidades] = useState(false);
	const [uniPlaceholder, setUniPlaceholder] = useState('Selecione a Unidade');

	const [dataRank, setDataRank] = useState(moment().format('DD/MM/YYYY'));
	const [dataRankPre, setDataRankPre] = useState(moment().format('DD/MM/YYYY'));
	const [dataRankDiaSemana, setDataRankDiaSemana] = useState('');
	const [calendarRankDropDown, setCalendarRankDropdown] = useState(false);
	const [filtroDiaRank, setFiltroDiaRank] = useState('Hoje');
	const [loadingDataRank, setLoadingDataRank] = useState(true);
	const [rankInfo, setRankInfo] = useState({
		data: [
			{ total: 0, cidade: 'Manaus', quantity: 0 },
			{ total: 0, cidade: 'P.Figueredo', quantity: 0 },
			{ total: 0, cidade: 'Boa Vista', quantity: 0 },
			{ total: 0, cidade: 'Rondonia', quantity: 0 },
			{ total: 0, cidade: 'Rio branco', quantity: 0 },
			{ total: 0, cidade: 'Amapa', quantity: 0 },
			{ total: 0, cidade: 'Bonfim', quantity: 0 },
			{ total: 0, cidade: 'Rorainopolis', quantity: 0 },
		],
	});
	const [rankingLabel, setRankingLabel] = useState('Total transacionado');

	const [range, setRange] = useState([
		{
			startDate: stringToDate(dataCartaoPre),
			endDate: stringToDate(dataCartao),
			key: 'selection',
		},
	]);

	const [rangeOperacao, setRangeOperacao] = useState([
		{
			startDate: stringToDate(dataOpPre),
			endDate: stringToDate(dataOp),
			key: 'selection',
		},
	]);
	const [rangeUnidade, setRangeUnidade] = useState([
		{
			startDate: stringToDate(dataUniPre),
			endDate: stringToDate(dataUni),
			key: 'selection',
		},
	]);
	const [rangeRank, setRangeRank] = useState([
		{
			startDate: stringToDate(dataUniPre),
			endDate: stringToDate(dataUni),
			key: 'selection',
		},
	]);

	/*function calcTotal(item) {
		var total = 0;
		for (let i = 0; i < item.length; i++) {
			total = total + parseFloat(item[i].valor);
		}
		return total;
	}*/

	function calcTotalRank(item) {
		var total = 0;
		for (let i = 0; i < item.length; i++) {
			total = total + parseFloat(item[i].total);
		}
		return total;
	}

	function handleChangeRange(item) {
		setRange([item.selection]);
		setDataCartaoDiaSemana(diaDaSemana[item.selection.endDate.getDay()]);

		////console.log(item.selection);

		const strDate = `${
			item.selection.startDate.getDate() < 10
				? `0${item.selection.startDate.getDate()}`
				: item.selection.startDate.getDate()
		}/${
			item.selection.startDate.getMonth() + 1 < 10
				? `0${item.selection.startDate.getMonth() + 1}`
				: item.selection.startDate.getMonth() + 1
		}/${item.selection.startDate.getFullYear()}`;
		setDataCartaoPre(strDate);
		const posDate = `${
			item.selection.endDate.getDate() < 10
				? `0${item.selection.endDate.getDate()}`
				: item.selection.endDate.getDate()
		}/${
			item.selection.endDate.getMonth() + 1 < 10
				? `0${item.selection.endDate.getMonth() + 1}`
				: item.selection.endDate.getMonth() + 1
		}/${item.selection.endDate.getFullYear()}`;
		setDataCartao(posDate);
		//////console.log(posDate);
		setCalendarCartaoDropdown(false);
		//setLoadingDataCartao(true);
		//console.log(item);

		getDashCartaoFilter(strDate, posDate);
	}

	function handleChangeRangeOperacao(item) {
		setRangeOperacao([item.selection]);
		setDataOpDiaSemana(diaDaSemana[item.selection.endDate.getDay()]);

		//////console.log(item.selection);

		const strDate = `${
			item.selection.startDate.getDate() < 10
				? `0${item.selection.startDate.getDate()}`
				: item.selection.startDate.getDate()
		}/${
			item.selection.startDate.getMonth() + 1 < 10
				? `0${item.selection.startDate.getMonth() + 1}`
				: item.selection.startDate.getMonth() + 1
		}/${item.selection.startDate.getFullYear()}`;
		setDataOpPre(strDate);
		const posDate = `${
			item.selection.endDate.getDate() < 10
				? `0${item.selection.endDate.getDate()}`
				: item.selection.endDate.getDate()
		}/${
			item.selection.endDate.getMonth() + 1 < 10
				? `0${item.selection.endDate.getMonth() + 1}`
				: item.selection.endDate.getMonth() + 1
		}/${item.selection.endDate.getFullYear()}`;
		setDataOp(posDate);
		setCalendarOpDropdown(false);

		getDashOperacaoFilter(strDate, posDate);
	}

	function handleChangeRangeUni(item) {
		setRangeUnidade([item.selection]);

		setDataUniDiaSemana(diaDaSemana[item.selection.endDate.getDay()]);

		////console.log(item.selection);

		const strDate = `${
			item.selection.startDate.getDate() < 10
				? `0${item.selection.startDate.getDate()}`
				: item.selection.startDate.getDate()
		}/${
			item.selection.startDate.getMonth() + 1 < 10
				? `0${item.selection.startDate.getMonth() + 1}`
				: item.selection.startDate.getMonth() + 1
		}/${item.selection.startDate.getFullYear()}`;
		setDataUniPre(strDate);
		const posDate = `${
			item.selection.endDate.getDate() < 10
				? `0${item.selection.endDate.getDate()}`
				: item.selection.endDate.getDate()
		}/${
			item.selection.endDate.getMonth() + 1 < 10
				? `0${item.selection.endDate.getMonth() + 1}`
				: item.selection.endDate.getMonth() + 1
		}/${item.selection.endDate.getFullYear()}`;
		setDataUni(posDate);
		setCalendarUniDropdown(false);
		//getDashCartaoFilter(strDate, posDate);

		getDashUnidadesFilter(strDate, posDate);
	}

	function handleChangeRangeRank(item) {
		setRangeRank([item.selection]);

		setDataRankDiaSemana(diaDaSemana[item.selection.endDate.getDay()]);

		////console.log(item.selection);

		const strDate = `${
			item.selection.startDate.getDate() < 10
				? `0${item.selection.startDate.getDate()}`
				: item.selection.startDate.getDate()
		}/${
			item.selection.startDate.getMonth() + 1 < 10
				? `0${item.selection.startDate.getMonth() + 1}`
				: item.selection.startDate.getMonth() + 1
		}/${item.selection.startDate.getFullYear()}`;
		setDataRankPre(strDate);
		const posDate = `${
			item.selection.endDate.getDate() < 10
				? `0${item.selection.endDate.getDate()}`
				: item.selection.endDate.getDate()
		}/${
			item.selection.endDate.getMonth() + 1 < 10
				? `0${item.selection.endDate.getMonth() + 1}`
				: item.selection.endDate.getMonth() + 1
		}/${item.selection.endDate.getFullYear()}`;
		setDataRank(posDate);
		setCalendarRankDropdown(false);

		getDashRankingFilter(strDate, posDate);
	}

	function handleChangeDropdown(dia) {
		if (dia !== 'Personalizado') {
			setCalendarCartaoDropdown(false);
		}

		if (dia === 'Hoje') {
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataCartaoDiaSemana(diaDaSemana[d]);

			setRange([
				{
					startDate: stringToDate(now),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataCartao(now);
			setDataCartaoPre(now);
			getDashCartaoFilter(now, now);
		} else if (dia === 'Ontem') {
			const x = moment().subtract(1, 'days').format('DD/MM/YYYY');
			setDataCartao(x);
			const y = moment().subtract(1, 'days').weekday();
			setDataCartaoDiaSemana(diaDaSemana[y]);
			setDataCartaoPre(x);

			setRange([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(x),
					key: 'selection',
				},
			]);
			getDashCartaoFilter(x, x);
		} else if (dia === 'Últimos 30 dias') {
			const x = moment().subtract(30, 'days').format('DD/MM/YYYY');
			setDataCartaoPre(x);
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataCartaoDiaSemana(diaDaSemana[d]);

			setRange([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataCartao(now);
			getDashCartaoFilter(x, now);
		} else if (dia === 'Este mês') {
			let now = moment().format('DD/MM/YYYY');
			let split = now.split('/');
			let y = split[0];
			const x = moment()
				.subtract(y - 1, 'days')
				.format('DD/MM/YYYY');
			////console.log(x);
			setDataCartaoPre(x);
			//let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataCartaoDiaSemana(diaDaSemana[d]);

			setDataCartao(now);

			setRange([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);
			getDashCartaoFilter(x, now);
		}

		setFiltroDiaCartao(dia);
		if (dia !== 'Personalizado') {
		}
	}

	function handleChangeDropdownOperacao(dia) {
		if (dia !== 'Personalizado') {
			setCalendarOpDropdown(false);
		}

		if (dia === 'Hoje') {
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataOpDiaSemana(diaDaSemana[d]);

			setRangeOperacao([
				{
					startDate: stringToDate(now),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataOp(now);
			setDataOpPre(now);
			getDashOperacaoFilter(now, now);
		} else if (dia === 'Ontem') {
			const x = moment().subtract(1, 'days').format('DD/MM/YYYY');
			setDataOp(x);
			const y = moment().subtract(1, 'days').weekday();
			setDataOpDiaSemana(diaDaSemana[y]);
			setDataOpPre(x);

			setRangeOperacao([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(x),
					key: 'selection',
				},
			]);
			getDashOperacaoFilter(x, x);
		} else if (dia === 'Últimos 30 dias') {
			const x = moment().subtract(30, 'days').format('DD/MM/YYYY');
			setDataOpPre(x);
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataOpDiaSemana(diaDaSemana[d]);

			setRangeOperacao([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataOp(now);
			getDashOperacaoFilter(x, now);
		} else if (dia === 'Este mês') {
			let now = moment().format('DD/MM/YYYY');
			let split = now.split('/');
			let y = split[0];
			const x = moment()
				.subtract(y - 1, 'days')
				.format('DD/MM/YYYY');
			////console.log(x);
			setDataOpPre(x);
			//let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataOpDiaSemana(diaDaSemana[d]);

			setDataOp(now);

			setRangeOperacao([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);
			getDashOperacaoFilter(x, now);
		}

		setFiltroDiaOp(dia);
		if (dia !== 'Personalizado') {
		}
	}

	function handleChangeDropdownUni(dia) {
		if (dia !== 'Personalizado') {
			setCalendarUniDropdown(false);
		}

		if (dia === 'Hoje') {
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataUniDiaSemana(diaDaSemana[d]);

			setRangeUnidade([
				{
					startDate: stringToDate(now),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataUni(now);
			setDataUniPre(now);
			getDashUnidadesFilter(now, now);
		} else if (dia === 'Ontem') {
			const x = moment().subtract(1, 'days').format('DD/MM/YYYY');
			setDataUni(x);
			const y = moment().subtract(1, 'days').weekday();
			setDataUniDiaSemana(diaDaSemana[y]);
			setDataUniPre(x);

			setRangeUnidade([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(x),
					key: 'selection',
				},
			]);
			getDashUnidadesFilter(x, x);
		} else if (dia === 'Últimos 30 dias') {
			const x = moment().subtract(30, 'days').format('DD/MM/YYYY');
			setDataUniPre(x);
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataUniDiaSemana(diaDaSemana[d]);

			setRangeUnidade([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataUni(now);
			getDashUnidadesFilter(x, now);
		} else if (dia === 'Este mês') {
			let now = moment().format('DD/MM/YYYY');
			let split = now.split('/');
			let y = split[0];
			const x = moment()
				.subtract(y - 1, 'days')
				.format('DD/MM/YYYY');
			////console.log(x);
			setDataUniPre(x);
			//let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataUniDiaSemana(diaDaSemana[d]);

			setDataUni(now);

			setRangeUnidade([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);
			getDashUnidadesFilter(x, now);
		}

		setFiltroDiaUni(dia);
		if (dia !== 'Personalizado') {
			//getDashUnidades();
		}
	}

	function handleChangeDropdownRank(dia) {
		if (dia !== 'Personalizado') {
			setCalendarRankDropdown(false);
		}

		if (dia === 'Hoje') {
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataRankDiaSemana(diaDaSemana[d]);

			setRangeRank([
				{
					startDate: stringToDate(now),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataRank(now);
			setDataRankPre(now);
			getDashRankingFilter(now, now);
		} else if (dia === 'Ontem') {
			const x = moment().subtract(1, 'days').format('DD/MM/YYYY');
			setDataRank(x);
			const y = moment().subtract(1, 'days').weekday();
			setDataRankDiaSemana(diaDaSemana[y]);
			setDataRankPre(x);

			setRangeRank([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(x),
					key: 'selection',
				},
			]);
			getDashRankingFilter(x, x);
		} else if (dia === 'Últimos 30 dias') {
			const x = moment().subtract(30, 'days').format('DD/MM/YYYY');
			setDataRankPre(x);
			let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataRankDiaSemana(diaDaSemana[d]);

			setRangeRank([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);

			setDataRank(now);
			getDashRankingFilter(x, now);
		} else if (dia === 'Este mês') {
			let now = moment().format('DD/MM/YYYY');
			let split = now.split('/');
			let y = split[0];
			const x = moment()
				.subtract(y - 1, 'days')
				.format('DD/MM/YYYY');
			////console.log(x);
			setDataRankPre(x);
			//let now = moment().format('DD/MM/YYYY');
			let d = moment().weekday();
			setDataRankDiaSemana(diaDaSemana[d]);

			setDataRank(now);

			setRangeRank([
				{
					startDate: stringToDate(x),
					endDate: stringToDate(now),
					key: 'selection',
				},
			]);
			getDashRankingFilter(x, now);
		}

		setFiltroDiaRank(dia);
		if (dia !== 'Personalizado') {
			//getDashRanking();
		}
	}

	function handleRankingChange(label) {
		//console.log(label)
		setRankingLabel(label);
		getDashRanking(label);
	}

	function Start() {
		let now = moment().format('DD/MM/YYYY');
		let d = moment().weekday();

		setDataCartaoDiaSemana(diaDaSemana[d]);
		//setDataCartao(now);
		//setDataCartaoPre(now);
		setRange([
			{
				startDate: moment(now, 'DD/MM/YYYY').toDate(),
				endDate: moment(now, 'DD/MM/YYYY').toDate(),
				key: 'selection',
			},
		]);

		setDataOpDiaSemana(diaDaSemana[d]);
		//setDataOp(now);
		//setDataOpPre(now);
		setRangeOperacao([
			{
				startDate: moment(now, 'DD/MM/YYYY').toDate(),
				endDate: moment(now, 'DD/MM/YYYY').toDate(),
				key: 'selection',
			},
		]);

		setDataUniDiaSemana(diaDaSemana[d]);
		//setDataUni(now);
		//setDataUniPre(now);
		setRangeUnidade([
			{
				startDate: moment(now, 'DD/MM/YYYY').toDate(),
				endDate: moment(now, 'DD/MM/YYYY').toDate(),
				key: 'selection',
			},
		]);

		setDataRankDiaSemana(diaDaSemana[d]);
		//setDataRank(now);
		//setDataRankPre(now);
		setRangeRank([
			{
				startDate: moment(now, 'DD/MM/YYYY').toDate(),
				endDate: moment(now, 'DD/MM/YYYY').toDate(),
				key: 'selection',
			},
		]);

		getDashCartao();
		getDashOperacao();
		getDashUnidades();
		getDashRanking();
		getUnidades();
	}

	useEffect(() => {
		Start();
	}, []);

	async function getDashCartao() {
		setLoadingDataCartao(true);

		try {
			const response = await api.get(
				`/admin/dashboard/resume?data_inicial=${dataCartaoPre}&data_final=${dataCartao}`
			);

			const { data, status } = response;
			////console.log(response);

			if (status === 200 && data) {
				const newData = response.data;
				//console.log(newData)
				setCartaoInfo(newData);
			}
			setLoadingDataCartao(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataCartao(false);
		}
	}

	async function getDashCartaoFilter(dataPre, dataPos) {
		setLoadingDataCartao(true);

		try {
			const response = await api.get(
				`/admin/dashboard/resume?data_inicial=${dataPre}&data_final=${dataPos}`
			);

			const { data, status } = response;
			////console.log(response);

			if (status === 200 && data) {
				const newData = response.data;
				//console.log(newData)
				setCartaoInfo(newData);
			}
			setLoadingDataCartao(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataCartao(false);
		}
	}

	async function getDashOperacaoFilter(dataPre, dataPos) {
		setLoadingDataOp(true);
		ValueCredit();

		//return;

		try {
			const response = await api.get(
				`/admin/dashboard/operation?data_inicial=${dataPre}&data_final=${dataPos}`
			);

			const { data, status } = response;
			////console.log(response);
			if (status === 200 && data) {
				const newData = response.data;

				setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoadingDataOp(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataOp(false);
		}
	}

	async function getDashOperacao() {
		setLoadingDataOp(true);
		ValueCredit();

		//return;

		try {
			const response = await api.get(
				`/admin/dashboard/operation?data_inicial=${dataOpPre}&data_final=${dataOp}`
			);

			const { data, status } = response;
			////console.log(response);
			if (status === 200 && data) {
				const newData = response.data;

				setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoadingDataOp(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataOp(false);
		}
	}

	async function getDashUnidadesFilter(dataPre, dataPos) {
		setLoadingDataUni(true);

		try {
			const response = await api.get(
				`/admin/dashboard/unidad?data_inicial=${dataPre}&data_final=${dataPos}&s=${unidade}`
			);

			const { data, status } = response;
			//console.log(response);
			if (status === 200 && data) {
				if (data.length === 0) {
					setUnidadeInfo({
						nome: unidade,
						data: [
							{
								valor: 0,
								nome: 'Credito a Vista',
								color: '#D3DCB7',
								percent: 0,
							},
							{
								valor: 0,
								nome: 'Credito Parcelado',
								color: '#F0F3E7',
								percent: 0,
							},
							{
								valor: 0,
								nome: 'Débito',
								color: '#7D9828',
								percent: 0,
							},
						],
					});
				} else {
					const newData = response.data;
					////console.log(newData);
					setUnidadeInfo({
						nome: newData.unidade,
						data: [
							{
								valor: newData.credit.total,
								nome: 'Credito a Vista',
								color: '#D3DCB7',
								percent: newData.credit.percent,
							},
							{
								valor: newData.credit_parceled.total,
								nome: 'Credito Parcelado',
								color: '#F0F3E7',
								percent: newData.credit_parceled.percent,
							},
							{
								valor: newData.debit.total,
								nome: 'Débito',
								color: '#7D9828',
								percent: newData.debit.percent,
							},
						],
					});
				}
				//setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoadingDataUni(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataUni(false);
		}
	}

	async function getDashUnidadesFilterNome(uniNome) {
		setLoadingDataUni(true);

		setUniPlaceholder(uniNome);
		setUnidadeSearch('');

		try {
			const response = await api.get(
				`/admin/dashboard/unidad?data_inicial=${dataUniPre}&data_final=${dataUni}&s=${uniNome}`
			);

			const { data, status } = response;
			//console.log(response);
			if (status === 200 && data) {
				if (data.length === 0) {
					setUnidadeInfo({
						nome: unidade,
						data: [
							{
								valor: 0,
								nome: 'Credito a Vista',
								color: '#D3DCB7',
								percent: 0,
							},
							{
								valor: 0,
								nome: 'Credito Parcelado',
								color: '#F0F3E7',
								percent: 0,
							},
							{
								valor: 0,
								nome: 'Débito',
								color: '#7D9828',
								percent: 0,
							},
						],
					});
				} else {
					const newData = response.data;
					////console.log(newData);
					setUnidadeInfo({
						nome: newData.unidade,
						data: [
							{
								valor: newData.credit.total,
								nome: 'Credito a Vista',
								color: '#D3DCB7',
								percent: newData.credit.percent,
							},
							{
								valor: newData.credit_parceled.total,
								nome: 'Credito Parcelado',
								color: '#F0F3E7',
								percent: newData.credit_parceled.percent,
							},
							{
								valor: newData.debit.total,
								nome: 'Débito',
								color: '#7D9828',
								percent: newData.debit.percent,
							},
						],
					});
				}

				//setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoadingDataUni(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataUni(false);
		}
	}

	async function getDashUnidades() {
		setLoadingDataUni(true);

		try {
			const response = await api.get(
				`/admin/dashboard/unidad?data_inicial=${dataUniPre}&data_final=${dataUni}&s=${unidade}`
			);

			const { data, status } = response;
			//console.log(response);
			if (status === 200 && data) {
				if (data.length === 0) {
					setUnidadeInfo({
						nome: unidade,
						data: [
							{
								valor: 0,
								nome: 'Credito a Vista',
								color: '#D3DCB7',
								percent: 0,
							},
							{
								valor: 0,
								nome: 'Credito Parcelado',
								color: '#F0F3E7',
								percent: 0,
							},
							{
								valor: 0,
								nome: 'Débito',
								color: '#7D9828',
								percent: 0,
							},
						],
					});
				} else {
					const newData = response.data;
					////console.log(newData);
					setUnidadeInfo({
						nome: newData.unidade,
						data: [
							{
								valor: newData.credit.total,
								nome: 'Credito a Vista',
								color: '#D3DCB7',
								percent: newData.credit.percent,
							},
							{
								valor: newData.credit_parceled.total,
								nome: 'Credito Parcelado',
								color: '#F0F3E7',
								percent: newData.credit_parceled.percent,
							},
							{
								valor: newData.debit.total,
								nome: 'Débito',
								color: '#7D9828',
								percent: newData.debit.percent,
							},
						],
					});
				}
				//setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoadingDataUni(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataUni(false);
		}
	}

	function TypeRank(label) {
		const data = [
			{
				label: 'Total transacionado',
				value: 'total',
			},
			{
				label: 'Ticket médio',
				value: 'ticket',
			},
			{
				label: 'Qtd. de pagamentos',
				value: 'quantity',
			},
		];
		const finder = data.find((d) => d.label === label);
		if (finder) return finder.value;
		else return '';
	}

	async function getDashRankingFilter(dataPre, dataPos) {
		setLoadingDataRank(true);

		const tipo = TypeRank(rankingLabel);

		try {
			const response = await api.get(
				`/admin/dashboard/ranking?data_inicial=${dataPre}&data_final=${dataPos}&type=${tipo}`
			);

			const { data, status } = response;
			//console.log(response);
			if (status === 200 && data) {
				const newData = response.data;
				////console.log(newData);

				setRankInfo({ data: newData });

				//setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoadingDataRank(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataRank(false);
		}
	}

	async function getDashRanking(label = rankingLabel) {
		setLoadingDataRank(true);

		const tipo = TypeRank(label);

		try {
			const response = await api.get(
				`/admin/dashboard/ranking?data_inicial=${dataRankPre}&data_final=${dataRank}&type=${tipo}`
			);

			const { data, status } = response;
			//	console.log(response);
			if (status === 200 && data) {
				const newData = response.data;
				////console.log(newData);

				setRankInfo({ data: newData });

				//setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoadingDataRank(false);
		} catch (error) {
			//alert('Error: ' + error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setLoadingDataRank(false);
		}
	}

	//	////console.log(stringToDate(dataCartaoPre));

	const CartaoRef = useRef(null);
	const OpRef = useRef(null);
	const UniRef = useRef(null);
	const RankRef = useRef(null);

	function handleClickOutsideCartao(e) {
		if (CartaoRef.current && !CartaoRef.current.contains(e.target)) {
			setCalendarCartaoDropdown(false);
		}
	}
	function handleClickOutsideOp(e) {
		if (OpRef.current && !OpRef.current.contains(e.target)) {
			setCalendarOpDropdown(false);
		}
	}
	function handleClickOutsideUni(e) {
		if (UniRef.current && !UniRef.current.contains(e.target)) {
			setCalendarUniDropdown(false);
		}
	}
	function handleClickOutsideRank(e) {
		if (RankRef.current && !RankRef.current.contains(e.target)) {
			setCalendarRankDropdown(false);
		}
	}

	useOutsideAlert(CartaoRef, handleClickOutsideCartao);
	useOutsideAlert(OpRef, handleClickOutsideOp);
	useOutsideAlert(UniRef, handleClickOutsideUni);
	useOutsideAlert(RankRef, handleClickOutsideRank);

	function ValueCredit() {
		/*	let total =
			operacaoInfo.debit.total +
			operacaoInfo.credit.total +
			operacaoInfo.credit_parceled.total;*/
		/*let debit = (operacaoInfo.debit.total * 100) / total;
		let credit = (operacaoInfo.credit.total * 100) / total;
		let credit_parceled = (operacaoInfo.credit_parceled.total * 100) / total;*/
		//setPorcentagemDebit(debit);
		//setPorcentagemcredit_parceled(credit_parceled);
		//setPorcentagemcredit(credit);
	}

	function roundToX(num, X) {
		return +(Math.round(num + 'e+' + X) + 'e-' + X);
	}

	const RankingData = [
		'Total transacionado',
		'Ticket médio',
		'Qtd. de pagamentos',
	];

	function getUnidades() {
		//var self = this;
		setLoadUnidades(true);
		//setState({ loading: true });

		const options = {
			headers: {
				'content-type': 'application/json',
				//'content-length': 89,
				'X-Forwarded-Host': X_FOWARD_HOST,
			},
		};

		api
			.get('/admin/unidade/json', options)
			.then(({ data, status }) => {
				if (status === 200) {
					//console.log(data);
					//if(data.unidades)
					setUnidades(data.unidades);
					setLoadUnidades(false);
				}
			})
			.catch((error) => {
				//////console.log(err);
				if (error.response.status === 401){
					window.location.reload(false);
					
				}
			});
	}

	function ShowRankingData() {
		let maxV = 0;
		const rankValue = TypeRank(rankingLabel);
		//console.log(rankInfo)

		if (rankValue === 'total')
			for (let i = 0; i < rankInfo.data.length; i++) {
				if (rankInfo.data[i].total > maxV) {
					maxV = rankInfo.data[i].total;
				}
			}
		else if (rankValue === 'ticket')
			for (let i = 0; i < rankInfo.data.length; i++) {
				if (rankInfo.data[i].total / rankInfo.data[i].quantity > maxV) {
					maxV = rankInfo.data[i].total / rankInfo.data[i].quantity;
				}
			}
		else {
			for (let i = 0; i < rankInfo.data.length; i++) {
				if (rankInfo.data[i].quantity > maxV) {
					maxV = rankInfo.data[i].quantity;
				}
			}
		}

		return rankInfo.data.map((item) => {
			let w = '0%';
			//////console.log(maxV);
			let valor =
				rankValue === 'total'
					? item.total
					: rankValue === 'ticket'
					? item.total / item.quantity
					: item.quantity;

			if (maxV === valor) {
				w = '100%';
			} else {
				let n = (valor * 100) / maxV;
				w = `${n}%`;
			}

			//////console.log(w);

			return (
				<div
					key={item.cidade}
					style={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						marginBlock: 8,
					}}>
					<div className='ranking-text-light' style={{ flex: 1.5 }}>
						{item.cidade}
					</div>
					<div style={{ flex: 5 }}>
						<div
							style={{
								width: w,
								background: '#7D9828',
								height: 8,
								borderRadius: 5,
							}}
						/>
					</div>
					{rankValue === 'total' ? (
						<NumberFormat
							className='ranking-text-medium'
							value={valor}
							thousandSeparator='.'
							decimalSeparator=','
							decimalScale={2}
							fixedDecimalScale={true}
							prefix='R$ '
							displayType='text'
							isAllowed={false}
							style={{
								flex: 2,
							}}></NumberFormat>
					) : rankValue === 'ticket' ? (
						<NumberFormat
							className='ranking-text-medium'
							value={valor}
							thousandSeparator='.'
							decimalSeparator=','
							decimalScale={2}
							fixedDecimalScale={true}
							prefix='R$ '
							displayType='text'
							isAllowed={false}
							style={{
								flex: 2,
							}}></NumberFormat>
					) : (
						<span style={{ flex: 2 }} className='ranking-text-medium'>
							{`${valor}`}
						</span>
					)}
				</div>
			);
		});
	}

	return (
		<div className='Informativo'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'> Dashboard</h2>
			</div>

			<div className='col-md'>
				<div className='card shadow border-radius-10'>
					{loadingDataCartao ? (
						<div
							style={{ margin: 0 }}
							className='card-body card-dash row space-between'>
							<div className='calendar-item-first'>
								<div className='calendar-icon'>
									<img src={calendarIcon} alt='Calendario' />
								</div>
								<div className='greenLine' />
								{
									<Dropdown
										style={{ maxWidth: 'fit-content' }}
										ref={CartaoRef}
										show={calendarCartaoDropDown}>
										<Dropdown.Toggle
											onClick={() => {
												setCalendarCartaoDropdown(!calendarCartaoDropDown);
											}}
											style={{
												backgroundColor: 'rgba(255,255,255,0)',
												color: '#7D9828',
												border: 0,
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												fontSize: 25,
												//lineHeight:39,
												justifyContent: 'flex-start',
												paddingLeft: 0,
												padding: 0,
											}}>
											<p
												style={{
													fontSize: 25,
													fontFamily: 'Roboto',
													fontWeight: '500',
													marginRight: 20,
													paddingVertical: 5,
													//lineHeight: 39,
												}}
												className='dropdown-calendar-text'>
												{filtroDiaCartao}
											</p>
										</Dropdown.Toggle>
										<CalendarDropDown
											handleChangeDropdown={handleChangeDropdown}
											handleChangeRange={handleChangeRange}
											range={range}
											filtroDia={filtroDiaCartao}
										/>
									</Dropdown>
								}
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{dataCartaoPre !== dataCartao
										? `de ${dataCartaoPre} até ${dataCartao}`
										: ` ${dataCartaoDiaSemana},
									${dataCartao}`}
								</p>
							</div>
							<div>
								<div
									style={{ width: 150, height: 80 }}
									className='Skeleton'></div>
							</div>
							<div>
								<div
									style={{ width: 150, height: 80 }}
									className='Skeleton'></div>
							</div>
							<div>
								<div
									style={{ width: 150, height: 80 }}
									className='Skeleton'></div>
							</div>
							<div>
								<div
									style={{ width: 150, height: 80 }}
									className='Skeleton'></div>
							</div>

							<div>
								<div
									style={{ width: 60, height: 80 }}
									className='Skeleton'></div>
							</div>
						</div>
					) : (
						<div
							style={{ margin: 0 }}
							className='card-body card-dash row space-between'>
							<div className='calendar-item-first'>
								<div className='calendar-icon'>
									<img src={calendarIcon} alt='Calendario' />
								</div>
								<div className='greenLine' />
								{
									<Dropdown
										style={{ maxWidth: 'fit-content' }}
										ref={CartaoRef}
										show={calendarCartaoDropDown}>
										<Dropdown.Toggle
											onClick={() => {
												setCalendarCartaoDropdown(!calendarCartaoDropDown);
											}}
											style={{
												backgroundColor: 'rgba(255,255,255,0)',
												color: '#7D9828',
												border: 0,
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												fontSize: 25,
												//lineHeight:39,
												justifyContent: 'flex-start',
												paddingLeft: 0,
												padding: 0,
											}}>
											<p
												style={{
													fontSize: 25,
													fontFamily: 'Roboto',
													fontWeight: '500',
													marginRight: 20,
													paddingVertical: 5,
													//lineHeight: 39,
												}}
												className='dropdown-calendar-text'>
												{filtroDiaCartao}
											</p>
										</Dropdown.Toggle>
										<CalendarDropDown
											handleChangeDropdown={handleChangeDropdown}
											handleChangeRange={handleChangeRange}
											range={range}
											filtroDia={filtroDiaCartao}
										/>
									</Dropdown>
								}
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{dataCartaoPre !== dataCartao
										? `de ${dataCartaoPre} até ${dataCartao}`
										: ` ${dataCartaoDiaSemana},
									${dataCartao}`}
								</p>
							</div>
							<div>
								<p
									className='dash-text-card'
									style={{ fontSize: 15, color: '#092A60' }}>
									Transações
								</p>
								<div style={{ width: 40 }} className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
									}}
									className='dropdown-calendar-text'>
									{cartaoInfo.amount.total}
								</p>
								<p
									className='dash-text-card font-weight-light'
									style={{
										fontSize: 14,
										color: '#092A60',
										//verticalAlign:''
									}}>
									{cartaoInfo.amount.percent > 0
										? '↑'
										: cartaoInfo.amount.percent === 0
										? ''
										: '↓ '}
									{`${cartaoInfo.amount.percent}%`}
								</p>
							</div>
							<div>
								<p
									className='dash-text-card'
									style={{ fontSize: 15, color: '#092A60' }}>
									R$ Transacionados
								</p>
								<div style={{ width: 40 }} className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
									}}
									className='dropdown-calendar-text'>
									<p style={{ fontSize: 15, marginRight: 10 }}>R$</p>
									{renderMoney(cartaoInfo.currency.total)}
								</p>
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{cartaoInfo.currency.percent > 0
										? '↑'
										: cartaoInfo.currency.percent === 0
										? ''
										: '↓'}
									{`${cartaoInfo.currency.percent}%`}
								</p>
							</div>
							<div>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<div
										style={{
											backgroundColor: '#ACBFD1',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									Maquininha
								</p>
								<div style={{ width: 40 }} className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
									}}
									className='dropdown-calendar-text'>
									{cartaoInfo.terminal.total}
								</p>
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{cartaoInfo.terminal.percent > 0
										? '↑'
										: cartaoInfo.terminal.percent === 0
										? ''
										: '↓'}
									{`${cartaoInfo.terminal.percent}%`}
								</p>
							</div>
							<div>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<div
										style={{
											backgroundColor: '#E3E9EF',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									WEB/APP
								</p>
								<div style={{ width: 40 }} className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
									}}
									className='dropdown-calendar-text'>
									{cartaoInfo.online.total}
								</p>
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{cartaoInfo.online.percent > 0
										? '↑'
										: cartaoInfo.online.percent === 0
										? ''
										: '↓'}
									{`${cartaoInfo.online.percent}%`}
								</p>
							</div>

							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									width: 60,
								}}>
								<ChartDonut
									ariaDesc='Proporção de vendas'
									ariaTitle='Donut Chart'
									data={[
										{ x: 'WEB/APP', y: cartaoInfo.online.total },
										{ x: 'Maquininha', y: cartaoInfo.terminal.total },
									]}
									labels={({ datum }) => `${datum.x}: ${datum.y}`}
									colorScale={['#E3E9EF', '#ACBFD1']}
									innerRadius={24}
									height={70}
									width={70}
									subTitle=''
									title=''
									padding={0}
									themeColor={ChartThemeColor.multiOrdered}
									constrainToVisibleArea={true}
								/>
							</div>
						</div>
					)}
				</div>
			</div>

			<div className='col-md mt-3'>
				<div className='card shadow border-radius-10'>
					{loadingDataOp ? (
						<div
							style={{ margin: 0 }}
							className='card-body card-dash row space-between'>
							<div className='calendar-item-first'>
								<div className='calendar-icon'>
									<img src={creditCard} alt='creditCard' />
								</div>
								<div className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: '500',
										marginRight: 20,
										paddingVertical: 5,
										color: '#7D9828',

										//lineHeight: 39,
									}}
									className='dropdown-calendar-text'>
									{'Operação'}
								</p>
								{
									<Dropdown
										style={{ maxWidth: 'fit-content' }}
										ref={OpRef}
										show={calendarOpDropDown}>
										<Dropdown.Toggle
											onClick={() => {
												setCalendarOpDropdown(!calendarOpDropDown);
											}}
											style={{
												backgroundColor: 'rgba(255,255,255,0)',
												color: '#092A60',
												border: 0,
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												fontSize: 18,
												//lineHeight:39,
												justifyContent: 'flex-start',
												paddingLeft: 0,
												padding: 0,
											}}>
											<p
												className='dash-text-card font-weight-light'
												style={{ fontSize: 14, color: '#092A60' }}>
												{dataOpPre !== dataOp
													? `de ${dataOpPre} até ${dataOp}`
													: ` ${dataOpDiaSemana},
									${dataOp}`}
											</p>
										</Dropdown.Toggle>

										<CalendarDropDown
											handleChangeDropdown={handleChangeDropdownOperacao}
											handleChangeRange={handleChangeRangeOperacao}
											range={rangeOperacao}
											filtroDia={filtroDiaOp}
										/>
									</Dropdown>
								}
							</div>

							<div>
								<div
									style={{ height: 80, width: 200 }}
									className='Skeleton'></div>
							</div>

							<div>
								<div
									style={{ height: 80, width: 200 }}
									className='Skeleton'></div>
							</div>

							<div>
								<div
									style={{ height: 80, width: 200 }}
									className='Skeleton'></div>
							</div>

							<div>
								<div
									style={{ height: 80, width: 60 }}
									className='Skeleton'></div>
							</div>
						</div>
					) : (
						<div
							style={{ margin: 0 }}
							className='card-body card-dash row space-between'>
							<div className='calendar-item-first'>
								<div className='calendar-icon'>
									<img src={creditCard} alt='creditCard' />
								</div>
								<div className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: '500',
										marginRight: 20,
										paddingVertical: 5,
										color: '#7D9828',

										//lineHeight: 39,
									}}
									className='dropdown-calendar-text'>
									{'Operação'}
								</p>
								{
									<Dropdown
										style={{ maxWidth: 'fit-content' }}
										ref={OpRef}
										show={calendarOpDropDown}>
										<Dropdown.Toggle
											onClick={() => {
												setCalendarOpDropdown(!calendarOpDropDown);
											}}
											style={{
												backgroundColor: 'rgba(255,255,255,0)',
												color: '#092A60',
												border: 0,
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												fontSize: 18,
												//lineHeight:39,
												justifyContent: 'flex-start',
												paddingLeft: 0,
												padding: 0,
											}}>
											<p
												className='dash-text-card font-weight-light'
												style={{ fontSize: 14, color: '#092A60' }}>
												{dataOpPre !== dataOp
													? `de ${dataOpPre} até ${dataOp}`
													: ` ${dataOpDiaSemana},
									${dataOp}`}
											</p>
										</Dropdown.Toggle>

										<CalendarDropDown
											handleChangeDropdown={handleChangeDropdownOperacao}
											handleChangeRange={handleChangeRangeOperacao}
											range={rangeOperacao}
											filtroDia={filtroDiaOp}
										/>
									</Dropdown>
								}
							</div>

							<div>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<div
										style={{
											backgroundColor: '#A8BA6F',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									Débito
								</p>
								<div style={{ width: 40 }} className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
									}}
									className='dropdown-calendar-text'>
									<p style={{ fontSize: 15, marginRight: 10 }}>R$</p>
									{renderMoney(operacaoInfo.debit.total)}
								</p>
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{`${roundToX(
										operacaoInfo.debit.percent,
										2
									)}% do total de transações`}
								</p>
							</div>

							<div>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<div
										style={{
											backgroundColor: '#D3DCB7',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									Crédito a Vista
								</p>
								<div style={{ width: 40 }} className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
									}}
									className='dropdown-calendar-text'>
									<p style={{ fontSize: 15, marginRight: 10 }}>R$</p>
									{renderMoney(operacaoInfo.credit.total)}
								</p>
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{`${roundToX(
										operacaoInfo.credit.percent,
										2
									)}% do total de transações`}
								</p>
							</div>

							<div>
								<p
									className='dash-text-card'
									style={{
										fontSize: 15,
										color: '#092A60',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<div
										style={{
											backgroundColor: '#F0F3E7',
											width: 12,
											height: 12,
											borderRadius: 4,
											marginRight: 5,
										}}
									/>
									Crédito Parcelado
								</p>
								<div style={{ width: 40 }} className='greenLine' />

								<p
									style={{
										fontSize: 25,
										fontFamily: 'Roboto',
										fontWeight: 'bold',
										marginRight: 20,
										paddingVertical: 5,
										//lineHeight: 39,
										color: '#7D9828',
										flexDirection: 'row',
										display: 'flex',
										alignItems: 'center',
									}}
									className='dropdown-calendar-text'>
									<p style={{ fontSize: 15, marginRight: 10 }}>R$</p>
									{renderMoney(operacaoInfo.credit_parceled.total)}
								</p>
								<p
									className='dash-text-card font-weight-light'
									style={{ fontSize: 14, color: '#092A60' }}>
									{`${roundToX(
										operacaoInfo.credit_parceled.percent,
										2
									)}% das transações`}
								</p>
							</div>

							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									width: 60,
								}}>
								<ChartDonut
									ariaDesc='Proporção de vendas'
									ariaTitle='Donut Chart'
									//constrainToVisibleArea={true}

									data={[
										{
											x: 'Crédito a Vista',
											y: operacaoInfo.credit.total,
										},
										{
											x: 'Crédito Parcelado',
											y: operacaoInfo.credit_parceled.total,
										},
										{ x: 'Débito', y: operacaoInfo.debit.total },
									]}
									labels={({ datum }) =>
										`${datum.x}: ${renderMoneyWithCedule(datum.y)}`
									}
									//labelPosition='endAngle'
									colorScale={['#D3DCB7', '#F0F3E7', '#A8BA6F']}
									innerRadius={30}
									height={90}
									width={90}
									subTitle=''
									title=''
									padding={0}
									themeColor={ChartThemeColor.multiOrdered}
									constrainToVisibleArea={true}
								/>
							</div>
						</div>
					)}
				</div>
			</div>

			<div style={{ margin: 0 }} className='col-md mt-3 row mb-3'>
				{loadingDataUni ? (
					<div
						style={{ flex: 1, paddingTop: 3 }}
						className='card shadow card-body mr-3 border-radius-10'>
						<div style={{}} className='card-body card-dash row space-between'>
							<div className='row' style={{ margin: 0 }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										flexDirection: 'column',
										marginRight: 15,
									}}>
									<img src={srMarker} alt='sr' />
									<div style={{ marginTop: 15 }} className='greenLine' />
								</div>
								<div>
									<p
										style={{
											fontSize: 25,
											fontFamily: 'Roboto',
											fontWeight: '500',
											marginRight: 20,
											paddingVertical: 5,
											color: '#7D9828',
											marginTop: -9,

											//lineHeight: 39,
										}}
										className='dropdown-calendar-text'>
										{'Unidade'}
									</p>
								</div>
							</div>
							<div className='border-radius-10'>
								<div
									style={{ height: 40, width: 200 }}
									className='Skeleton'></div>
							</div>
						</div>
						<div
							style={{ height: '100%', width: '100%' }}
							className='Skeleton'></div>
					</div>
				) : (
					<div
						style={{ flex: 1, paddingTop: 3 }}
						className='card shadow card-body mr-3 border-radius-10'>
						<div style={{}} className='card-body card-dash row space-between'>
							<div className='row-no-wrap' style={{ margin: 0, flex: 1 }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										flexDirection: 'column',
										marginRight: 15,
									}}>
									<img src={srMarker} alt='sr' />
									<div style={{ marginTop: 15 }} className='greenLine' />
								</div>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										flex: 1,
										justifyContent: 'space-between',
									}}>
									<div>
										<Dropdown
											style={{
												marginTop: -25,
												paddingTop: 10,

												width: 200,
											}}>
											<Dropdown.Toggle
												style={{
													backgroundColor: 'transparent',
													border: 0,
													color: '#7D9828',
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													fontSize: 20,
													//lineHeight:39,
													//justifyContent: 'flex-start',
													paddingLeft: 0,
													padding: 0,
													//marginTop: -9,
													//maxWidth:'60%'
													width: 200,
												}}>
												<input
													style={{
														fontSize: 25,
														fontFamily: 'Roboto',
														fontWeight: '500',
														marginRight: 5,
														padding: 0,
														alignSelf: 'flex-start',
														verticalAlign: 'text-top',
														color: '#7D9828',
														maxWidth: 190,

														//lineHeight: 39,
														//	background: 'transparent',

														//marginTop: -10,
														//paddingTop: 10,
													}}
													placeholder={uniPlaceholder}
													className='dropdown-calendar-text pesquisar-unidade-text border-radius-10 put-placeholder-green'
													value={unidadeSearch}
													onChange={(e) => {
														setUnidadeSearch(e.target.value);
													}}
												/>
												{
													//<p style={{fontSize:10}}>V</p>
												}

												{/*<p
												style={{
													fontSize: 25,
													fontFamily: 'Roboto',
													fontWeight: '500',
													marginRight: 5,
													padding: 0,
													alignSelf: 'flex-start',
													verticalAlign: 'text-top',
													//lineHeight: 39,
												}}
												className='dropdown-calendar-text'>
												{unidade}
											</p>*/}
											</Dropdown.Toggle>
											<Dropdown.Menu
												className='shadow menu-dropdown-overflow-uni'
												style={{
													background: '#F6F6F6',
													boxShadow: '#0000001A',
													borderWidth: 1,
													borderColor: '#EBEBEB',
													border: 'solid 1px #EBEBEB',
													padding: 10,
													display: 'flex',
													flexDirection: 'row',

													//transition: 'width 1s',
												}}>
												<div>
													{loadUnidades ? (
														<Dropdown.Item
															//key={uni.id}
															/*onClick={(e) => {
																		e.preventDefault();
																		setUnidade(uni.nome);
																		setUnidadeSearch(uni.nome);
																		getDashUnidadesFilterNome(uni.nome);
																		//handleRankingChange(rank);
																	}}*/
															className={'Dropdown-menu-item'}
															style={{
																//background: '#FFFFFF',
																//color: '#7D9828',
																fontFamily: 'Roboto',
																fontSize: 16,
																marginBottom: 5,
																borderRadius: 8,
															}}>
															{'Carregando unidades...'}
														</Dropdown.Item>
													) : (
														unidades.map((uni) => {
															if (
																replaceSpecialChars(
																	uni.nome.toLocaleLowerCase('tr')
																).includes(
																	replaceSpecialChars(
																		unidadeSearch.trim().toLocaleLowerCase('tr')
																	)
																)
															)
																return (
																	<Dropdown.Item
																		key={uni.id}
																		onClick={(e) => {
																			e.preventDefault();
																			setUnidade(uni.nome);
																			setUnidadeSearch(uni.nome);
																			getDashUnidadesFilterNome(uni.nome);
																			//handleRankingChange(rank);
																		}}
																		className={
																			uni.nome === unidade
																				? 'Dropdown-menu-item-selected'
																				: 'Dropdown-menu-item'
																		}
																		style={{
																			//background: '#FFFFFF',
																			//color: '#7D9828',
																			fontFamily: 'Roboto',
																			fontSize: 16,
																			marginBottom: 5,
																			borderRadius: 8,
																		}}>
																		{uni.nome}
																	</Dropdown.Item>
																);
															return null;
														})
													)}
												</div>
											</Dropdown.Menu>
										</Dropdown>
									</div>
									{
										<Dropdown
											drop={'up'}
											menuAlign='left'
											style={{ maxWidth: 'fit-content', marginTop: -15 }}
											ref={UniRef}
											show={calendarUniDropDown}>
											<Dropdown.Toggle
												onClick={() => {
													setCalendarUniDropdown(!calendarUniDropDown);
												}}
												style={{
													backgroundColor: 'rgba(255,255,255,0)',
													color: '#092A60',
													border: 0,
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													fontSize: 18,
													//lineHeight:39,
													justifyContent: 'flex-start',
													paddingLeft: 0,
													padding: 0,
												}}>
												<p
													className='dash-text-card font-weight-light'
													style={{ fontSize: 14, color: '#092A60' }}>
													{dataUniPre !== dataUni
														? `de ${dataUniPre} até ${dataUni}`
														: ` ${dataUniDiaSemana},
									${dataUni}`}
												</p>
											</Dropdown.Toggle>

											<CalendarDropDown
												dontShow={true}
												handleChangeDropdown={handleChangeDropdownUni}
												handleChangeRange={handleChangeRangeUni}
												range={rangeUnidade}
												filtroDia={filtroDiaUni}
											/>
										</Dropdown>
									}
								</div>
							</div>
							{/*<div className='pesquisar-unidade-container border-radius-10'>
								<img
									style={{ padding: 13, color: '#092A60' }}
									src={searchIcon}
									alt='search'
								/>
								{/*<input
									className='pesquisar-unidade-text border-radius-10'
									placeholder='Digite o nome de uma unidade'
									type='text'
									value={unidadeNomeSearch}
									onChange={(e) => {
										setUnidadeNomeSearch(e.target.value);
									}}
									name=''
									id=''
								/>}
							</div>*/}
						</div>
						<div>
							<p className='unidade-text'>{unidadeInfo.nome}</p>
						</div>

						<div>
							{unidadeInfo.data.map((item) => {
								let maxV = 0;
								//let maxW = 400;

								for (let i = 0; i < unidadeInfo.data.length; i++) {
									if (unidadeInfo.data[i].valor > maxV) {
										maxV = unidadeInfo.data[i].valor;
									}
								}
								let w = '0%';

								if (item.valor === maxV) {
									w = '90%';
								} else {
									let n = (item.valor * 90) / maxV;
									w = `${n}%`;
									//w = (maxW * item.valor) / maxV;
								}

								//////console.log(w);
								//////console.log(maxV);

								return (
									<div key={item.nome} className='container-grafico-barra'>
										<div
											style={{
												width: w,
												backgroundColor: item.color,
												height: 10,
												borderRadius: 5,
												marginRight: 10,
											}}
										/>
										<NumberFormat
											style={{ flex: 1 }}
											value={item.valor}
											thousandSeparator='.'
											decimalSeparator=','
											decimalScale={2}
											fixedDecimalScale={true}
											prefix='R$ '
											displayType='text'
											isAllowed={false}
											className='container-grafico-barra-texto'></NumberFormat>
									</div>
								);
							})}
						</div>
						<div className='container-grafico-legenda-row'>
							{unidadeInfo.data.map((item) => {
								return (
									<div key={item.nome} className='container-grafico-legenda'>
										<div
											className='container-grafico-legenda-icone'
											style={{
												background: item.color,
											}}
										/>
										<p
											style={{
												margin: 0,
												marginRight: 5,
												color: '#092A60',
												fontSize: 12,
											}}>
											{item.nome}
										</p>
									</div>
								);
							})}
						</div>
					</div>
				)}

				{loadingDataRank ? (
					<div
						style={{ flex: 1, paddingTop: 3 }}
						className='card shadow card-body border-radius-10'>
						<div className='padding-125-rem card-dash row space-between align-items-start'>
							<div className='row' style={{ margin: 0 }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										flexDirection: 'column',
										marginRight: 15,
									}}>
									<img src={TrophyIcon} alt='trophy' />
									<div style={{ marginTop: 15 }} className='greenLine' />
								</div>
								<div>
									<Dropdown style={{ maxWidth: 'fit-content' }}>
										<Dropdown.Toggle
											style={{
												backgroundColor: 'rgba(255,255,255,0)',
												color: '#7D9828',
												border: 0,
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												fontSize: 25,
												//lineHeight:39,
												justifyContent: 'flex-start',
												paddingLeft: 0,
												padding: 0,
												marginTop: -9,
											}}>
											<p
												style={{
													fontSize: 25,
													fontFamily: 'Roboto',
													fontWeight: '500',
													marginRight: 5,
													padding: 0,
													alignSelf: 'flex-start',
													verticalAlign: 'text-top',
													//lineHeight: 39,
												}}
												className='dropdown-calendar-text'>
												{rankingLabel}
											</p>
										</Dropdown.Toggle>
										<Dropdown.Menu
											className='shadow'
											style={{
												background: '#F6F6F6',
												boxShadow: '#0000001A',
												borderWidth: 1,
												borderColor: '#EBEBEB',
												border: 'solid 1px #EBEBEB',
												padding: 10,
												display: 'flex',
												flexDirection: 'row',

												//transition: 'width 1s',
											}}>
											<div>
												{RankingData.map((rank) => {
													return (
														<Dropdown.Item
															key={rank}
															onClick={(e) => {
																e.preventDefault();
																handleRankingChange(rank);
															}}
															className={
																rankingLabel === rank
																	? 'Dropdown-menu-item-selected'
																	: 'Dropdown-menu-item'
															}
															style={{
																//background: '#FFFFFF',
																//color: '#7D9828',
																fontFamily: 'Roboto',
																fontSize: 16,
																marginBottom: 5,
																borderRadius: 8,
															}}>
															{rank}
														</Dropdown.Item>
													);
												})}
											</div>
										</Dropdown.Menu>
									</Dropdown>

									{
										<Dropdown
											drop={'left'}
											menuAlign='up'
											style={{ maxWidth: 'fit-content' }}
											ref={RankRef}
											show={calendarRankDropDown}>
											<Dropdown.Toggle
												onClick={() => {
													setCalendarRankDropdown(!calendarRankDropDown);
												}}
												style={{
													backgroundColor: 'rgba(255,255,255,0)',
													color: '#092A60',
													border: 0,
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													fontSize: 18,
													//lineHeight:39,
													justifyContent: 'flex-start',
													paddingLeft: 0,
													padding: 0,
												}}>
												<p
													className='dash-text-card font-weight-light'
													style={{ fontSize: 14, color: '#092A60' }}>
													{dataRankPre !== dataRank
														? `de ${dataRankPre} até ${dataRank}`
														: ` ${dataRankDiaSemana},
									${dataRank}`}
												</p>
											</Dropdown.Toggle>

											<CalendarDropDown
												handleChangeDropdown={handleChangeDropdownRank}
												handleChangeRange={handleChangeRangeRank}
												range={rangeRank}
												filtroDia={filtroDiaRank}
											/>
										</Dropdown>
									}
								</div>
							</div>{' '}
						</div>

						<div className='lista-rank-cidade' ref={secondChart}>
							<div style={{ height: 140 }} className='Skeleton'></div>
						</div>
					</div>
				) : (
					<div
						style={{ flex: 1, paddingTop: 3 }}
						className='card shadow card-body border-radius-10'>
						<div className='padding-125-rem card-dash row space-between align-items-start'>
							<div className='row' style={{ margin: 0 }}>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										flexDirection: 'column',
										marginRight: 15,
									}}>
									<img src={TrophyIcon} alt='trophy' />
									<div style={{ marginTop: 15 }} className='greenLine' />
								</div>
								<div>
									<Dropdown style={{ maxWidth: 'fit-content' }}>
										<Dropdown.Toggle
											style={{
												backgroundColor: 'rgba(255,255,255,0)',
												color: '#7D9828',
												border: 0,
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												fontSize: 25,
												//lineHeight:39,
												justifyContent: 'flex-start',
												paddingLeft: 0,
												padding: 0,
												marginTop: -9,
											}}>
											<p
												style={{
													fontSize: 25,
													fontFamily: 'Roboto',
													fontWeight: '500',
													marginRight: 5,
													padding: 0,
													alignSelf: 'flex-start',
													verticalAlign: 'text-top',
													//lineHeight: 39,
												}}
												className='dropdown-calendar-text'>
												{rankingLabel}
											</p>
										</Dropdown.Toggle>
										<Dropdown.Menu
											className='shadow'
											style={{
												background: '#F6F6F6',
												boxShadow: '#0000001A',
												borderWidth: 1,
												borderColor: '#EBEBEB',
												border: 'solid 1px #EBEBEB',
												padding: 10,
												display: 'flex',
												flexDirection: 'row',

												//transition: 'width 1s',
											}}>
											<div>
												{RankingData.map((rank) => {
													return (
														<Dropdown.Item
															key={rank}
															onClick={(e) => {
																e.preventDefault();
																handleRankingChange(rank);
															}}
															className={
																rankingLabel === rank
																	? 'Dropdown-menu-item-selected'
																	: 'Dropdown-menu-item'
															}
															style={{
																//background: '#FFFFFF',
																//color: '#7D9828',
																fontFamily: 'Roboto',
																fontSize: 16,
																marginBottom: 5,
																borderRadius: 8,
															}}>
															{rank}
														</Dropdown.Item>
													);
												})}
											</div>
										</Dropdown.Menu>
									</Dropdown>
									{
										<Dropdown
											drop={'left'}
											style={{ maxWidth: 'fit-content' }}
											ref={RankRef}
											show={calendarRankDropDown}>
											<Dropdown.Toggle
												onClick={() => {
													setCalendarRankDropdown(!calendarRankDropDown);
												}}
												style={{
													backgroundColor: 'rgba(255,255,255,0)',
													color: '#092A60',
													border: 0,
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													fontSize: 18,
													//lineHeight:39,
													justifyContent: 'flex-start',
													paddingLeft: 0,
													padding: 0,
												}}>
												<p
													className='dash-text-card font-weight-light'
													style={{ fontSize: 14, color: '#092A60' }}>
													{dataRankPre !== dataRank
														? `de ${dataRankPre} até ${dataRank}`
														: ` ${dataRankDiaSemana},
									${dataRank}`}
												</p>
											</Dropdown.Toggle>

											<CalendarDropDown
												alignUp={true}
												handleChangeDropdown={handleChangeDropdownRank}
												handleChangeRange={handleChangeRangeRank}
												range={rangeRank}
												filtroDia={filtroDiaRank}
											/>
										</Dropdown>
									}
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									flexDirection: 'row',
								}}>
								<p className='ranking-valor-simbolo'>{'R$'}</p>
								<p className='ranking-valor'>
									{renderMoney(calcTotalRank(rankInfo.data))}
								</p>
							</div>
						</div>

						<div className='lista-rank-cidade' ref={secondChart}>
							{rankInfo.data.length > 0 ? (
								<ShowRankingData />
							) : (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										height: '100%',
									}}>
									<p style={{ fontSize: 16 }}>
										Nenhuma informação disponivel para essa data
									</p>
								</div>
							)}
						</div>
						<div className='container-grafico-legenda-row'>
							<p
								style={{
									margin: 0,
									color: '#092a60',
									fontSize: 12,
									marginTop: 10,
								}}>
								Valores transacionados nos pontos de venda instalados em cada
								cidade.
							</p>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

function useOutsideAlert(ref, handleClickOutside) {
	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref]);
}

export default Dash;
